import React from 'react';
import { CTAButton } from '../CTAButton';
import { SectionHeading } from '../SectionHeading';
import { tools } from '../../data/landing';
export function Tools() {
  return <section className="bg-white" data-id="element-371" data-mp="2hk1dr9sq12s6">
      <div className="mx-auto max-w-3xl px-5 py-14 md:py-20" data-id="element-372" data-mp="2hj04nav9mqd3">
        <SectionHeading title={<>And I'm including these <em className="text-teal-dark" data-id="element-374" data-mp="2dhoacs1g5gyk">practical tools</em></>} data-id="element-373" data-mp="2dig3lw7kn2lo" />

        <ul className="mt-10 grid gap-3 sm:grid-cols-2" data-id="element-375" data-mp="28jv6i5nm8z1g">
          {tools.map((t, i) => {
          const Icon = t.icon;
          return <li key={t.title} className={`flex gap-4 rounded-2xl bg-teal-soft p-5 ${i === 0 ? 'sm:col-span-2' : ''}`} data-id="element-376" data-mp="23rbtb9suc5x6" data-mpi={i}>
                <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-teal text-white" data-id="element-377" data-mp="1tvi5gu9o8q03">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-378" data-mp="1prk92rbqdtaq" />
                </span>
                <div data-id="element-379" data-mp="1kutte53u8zpu">
                  <h3 className="text-lg font-black text-navy" data-id="element-380" data-mp="1kuai378p19ks">{t.title}</h3>
                  <p className="mt-1 text-base leading-relaxed text-navy/75" data-id="element-381" data-mp="158erx9k2s0w8">{t.body}</p>
                </div>
              </li>;
        })}
        </ul>

        <div className="mt-10" data-id="element-382" data-mp="w91hoeo4n8ag">
          <CTAButton label="Yes, I want access to the complete system" data-id="element-383" data-mp="w9t2qvk3lnmh" />
        </div>
      </div>
    </section>;
}